import { aiModelEntities } from 'shared/entities/smartbotAI/client';
import { AIModelKind } from 'shared/entities/smartbotAI/server';

import {
  ActualNameCreator,
  createActualBlockName,
  normalizeCommonFields
} from '../common';

import {
  ConditionLlmClassificationNormalizer,
  DEFAULT_LLM_GPT_MODEL_TYPE,
  IConditionLlmClassificationParams
} from './client';

const getModelTitle = (modelKind: string | null): string => {
  if (!modelKind) {
    return aiModelEntities[DEFAULT_LLM_GPT_MODEL_TYPE]?.title ?? '';
  }
  return aiModelEntities[modelKind as AIModelKind]?.title ?? modelKind;
};

export const createLlmClassificationActualName: ActualNameCreator<
  IConditionLlmClassificationParams
> = ({ params, t }) =>
  t('blocks.ConditionLlmClassification.nameWithModel', {
    ns: 'models',
    model: getModelTitle(params.gptModelType.value)
  });

export const normalizeConditionLlmClassification: ConditionLlmClassificationNormalizer =
  (raw, stores) => {
    return {
      ...normalizeCommonFields(raw, stores),
      actualName: (t) =>
        createActualBlockName({
          paramsName: t('blocks.ConditionLlmClassification.nameWithModel', {
            ns: 'models',
            model: getModelTitle(raw.params.gpt_model_type ?? null)
          }),
          blockKind: raw.kind,
          blockName: raw.name,
          t,
          ...stores
        })
    };
  };
